import React from 'react'
import { connect } from 'react-redux'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { browserHistory } from 'react-router'
import { hasAutomationPermissions } from '../../stores/usersStore'

import PollList from './PollList'
import FeaturedPollsList from './FeaturedPollsList'
import CustomerSelect from '../CustomerSelect/'

import IfAdmin from '../IfAdmin'
import { selectCurrentUser } from '../../stores/currentUser'
import { isAdmin, isLibrary } from '../../stores/usersStore'
import {
  getSelectedCustomerId,
  selectCustomer,
} from '../../stores/ui/selectedCustomer'
import { getSearch, setSearch, clearSearch } from '../../stores/ui/search'
import {
  LIBRARY_URL_ALL,
  LIBRARY_URL_RECOMMENDED,
  AUTOMATIONS_URL,
} from '../../urls'
import AutomationPollsList from './AutomationPollsList'

export const onLoadLibrary = (location, shouldSeeLibrary, history) => {
  if (
    location &&
    location.pathname === LIBRARY_URL_RECOMMENDED &&
    !shouldSeeLibrary
  ) {
    history.push(LIBRARY_URL_ALL)
  }
}
const RECOMMENDED_TAB_INDEX = 0

export const getSelectedUrl = index => {
  switch (index) {
    case 0:
      return LIBRARY_URL_RECOMMENDED
    case 1:
      return LIBRARY_URL_ALL
    case 2:
      return AUTOMATIONS_URL
    default:
      return LIBRARY_URL_ALL
  }
}

export class LibraryPage extends React.Component {
  componentWillMount() {
    const { location, shouldSeeLibrary } = this.props
    onLoadLibrary(location, shouldSeeLibrary, browserHistory)
  }

  componentDidMount() {
    if (window.location.pathname === LIBRARY_URL_ALL && this.searchInput) {
      this.searchInput.focus()
    }
  }

  selectedTab = tab => {
    switch (tab) {
      case 'recommended':
        return 0
      case 'all':
        return 1
      case 'automation':
        return 2
      default:
        return 1
    }
  }

  isTabAllowed = index =>
    this.props.shouldSeeLibrary || index !== RECOMMENDED_TAB_INDEX

  render() {
    const {
      customerId,
      selectCustomer,
      hasAutomationPermissions,
      search = '',
      setSearch,
      clearSearch,
      shouldSeeLibrary,
      tab,
    } = this.props

    const selectedIndex = this.selectedTab(tab)

    const onSelect = index => {
      clearSearch()
      if (this.isTabAllowed(index)) {
        const url = getSelectedUrl(index)
        browserHistory.push(url)
      }
    }

    return (
      <div className="w-100">
        <Tabs selectedIndex={selectedIndex} onSelect={onSelect}>
          <TabList
            className="flex"
            activeTabClassName="bg-op-con-dark"
            style={{ margin: 0, padding: 0, border: 'none' }}
          >
            <Tab
              className="w-20 bg-op-con-medium pointer white f5 pa2 flex items-center mr2"
              style={shouldSeeLibrary ? null : { display: 'none' }}
            >
              Opinary Recommends
            </Tab>
            <Tab className="w-20 bg-op-con-medium pointer white f5 pa2 flex items-center mr2">
              All Polls
            </Tab>
            <Tab
              className="w-20 bg-op-con-medium pointer white f5 pa3 flex items-center"
              style={hasAutomationPermissions ? null : { display: 'none' }}
            >
              Automated Polls
            </Tab>

            <div className="w-50 flex mb2 ml-auto">
              <IfAdmin>
                <CustomerSelect
                  className="w-30 ml4 bb b--op-con-dark"
                  colorClass="op-con-dark"
                  onChange={selectCustomer}
                  customerId={customerId}
                  placeholder="View as"
                />
              </IfAdmin>
              <span className="flex items-center w-50 w-60-l bb op-con-dark b--op-con-dark ml-auto">
                <input
                  type="text"
                  placeholder="Type to search"
                  ref={input => {
                    this.searchInput = input
                  }}
                  onClick={() => browserHistory.push(LIBRARY_URL_ALL)}
                  onChange={event => setSearch(event.target.value)}
                  value={search || ''}
                  className="search-input flex-auto op-con-dark bg-transparent"
                />
                {search ? (
                  <i
                    className="fa fa-times mr1"
                    onClick={() => setSearch('')}
                  ></i>
                ) : null}
                <i className="fa fa-search"></i>
              </span>
            </div>
          </TabList>
          <TabPanel>
            <FeaturedPollsList />
          </TabPanel>
          <TabPanel>
            <PollList />
          </TabPanel>
          <TabPanel>
            <AutomationPollsList />
          </TabPanel>
        </Tabs>
      </div>
    )
  }
}

export default connect(
  state => {
    const user = selectCurrentUser(state)
    const shouldSeeLibrary = user != null && (isAdmin(user) || isLibrary(user))
    return {
      customerId: getSelectedCustomerId(state),
      search: getSearch(state),
      user,
      shouldSeeLibrary,
      userAgent: window.navigator.userAgent,
      location: window.location,
      hasAutomationPermissions: hasAutomationPermissions(user),
    }
  },
  {
    selectCustomer,
    setSearch,
    clearSearch,
  }
)(LibraryPage)



// WEBPACK FOOTER //
// ./src/components/LibraryPage/index.js